const Magento = {
    "heroSection":{
        "enable": true,
        "title":"Magento",
        "subtext":"<strong>we’re a leading Magento development</strong> company offering advanced solutions in development, design",
        "image": require('../images/magento/magento_img-1.png'),
        "class": "move-from-right"
    },
    "statistics": {
        "enable": true,
        "stats": [
            {
                "count": "50+",
                "content": "Projects<br/> delivered"
            },
            {
                "count": "100+",
                "content": "Talented,<br/> team"
            },
            {
                "count": "1000+",
                "content": "Happy Customers"
            }
        ]
    },
    "textQuoteWithImage":{
        "enable": true,
        "text" :"Offering flexibility, scalability and security is why Magento still rules the roster. We offer a certified team of Magento developers with over a decade of experience that help deliver solutions efficiently and effectively.",
        "image": require('../images/magento/magento_img-2.png'),
        "classes": "bounce-up-down-2",
        "logo": require('../images/client-logos/magento_logo.png')
    },
    "iconsWithHeadingText": {
        "enable": true,
        "title": "Our Services",
        "subheading": "WE’RE Magento experts",
        "blocks":[
            {
                "src": require('../svgs/website_design.svg'),
                "heading": "Magento Website Design",
                "content": "Distinguish your brand from competitors and increase revenue with a professionally designed website. Our creative team leverages talent atalent and experience to give you faster turnarounds."
            },
            {
                "src": require('../svgs/web_dev.svg'),
                "heading": "Magento Web Development",
                "content": "With certified Magento developers guiding our team, each website is fully optimized for efficiency and durability. Magento is our primary focus and we pride ourselves as a magento web development company in developing quality Magento websites and extensions."
            },
            {
                "src": require('../svgs/market_service.svg'),
                "heading": "Marketing Services",
                "content": "Amplify your online success with an online marketing campaign generating leads and revenue for your brand. Our marketing team increases your website’s rate of growth through targeted online campaigns."
            },
            {
                "src": require('../svgs/crm.svg'),
                "heading": "CRM and ERP integration",
                "content": "Boosting your sales has never been easier with seamless CRM-ERP integration combined with effortless Inventory Management solutions. With Hexamarvel, you can make your mark in the industry with third party CRM and ERP integration like Netsuite and MS-AX."
            }
        ]
    },
    "services":{
        "enable": true,
        "title": "<strong>Efficient and seamless</strong> Magento development solutions. Below are some of the features offered by Magento:",
        "subheading": "Magento E-COMMERCE Solutions",
        "list":["Shopping Cart", "Shipping Returns", "Multi Screen", "Universal Login", "SEO/SEM", "Hosting", "Server Management", "Analytics", "Content Management", "Loyalty & Rewards", "Media", "Social Media", "Alerts & Notifications", "Location & Services"]
    }
};

export default Magento;